import type { ChartType, Plugin } from "chart.js";

export function createVerticalHoverLinePlugin<TType extends ChartType>(lineColor: string): Plugin<TType> {
  return {
    id: "verticalHoverLine",
    afterDraw: (chart) => {
      const activeElements = chart.tooltip?.getActiveElements() ?? [];
      const verticalScale = chart.scales.y;
      if (activeElements.length === 0 || !verticalScale) return;
      const hoverX = activeElements[0].element.x;
      const context = chart.ctx;
      context.save();
      context.beginPath();
      context.moveTo(hoverX, verticalScale.top);
      context.lineTo(hoverX, verticalScale.bottom);
      context.lineWidth = 1;
      context.setLineDash([4, 4]);
      context.strokeStyle = lineColor;
      context.stroke();
      context.restore();
    },
  };
}
